import * as React from 'react';
import { SelectionSource } from 'Src/helpers/service/adminSU/highLevelTournament';

export function TournamentSelectionSources({sources = []}: {sources?: SelectionSource[]}) {
  if (!sources.length) return <span className="hltSelectionSources hltSelectionSources--manual">Added manually · source not recorded</span>;
  const render = (source: SelectionSource) => (
    <span className="hltSelectionSources__entry" key={`${source.tournamentId}:${source.eventId}`}>
      <strong>{source.tournamentName}</strong>
      <span>{source.eventName} · {source.place ? `${source.teamId ? 'Team place' : 'Place'} ${source.place}` : 'No recorded place'}
        {source.method === 'MANUAL' ? ' · manual selection' : ''}</span>
    </span>
  );
  return <div className="hltSelectionSources">{render(sources[0])}{sources.length > 1 && <details>
    <summary>{sources.length - 1} more selection source{sources.length > 2 ? 's' : ''}</summary>
    {sources.slice(1).map(render)}
  </details>}</div>;
}
